import { render, staticRenderFns } from "./ServiceVehicleInformation.vue?vue&type=template&id=f3019bf2&scoped=true&"
import script from "./ServiceVehicleInformation.vue?vue&type=script&lang=js&"
export * from "./ServiceVehicleInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3019bf2",
  null
  
)

export default component.exports